import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import {
  IApiRequest,
  ISelectOption,
  ISeriesGroupResponse,
} from "@miplatform/types";

export const useSeriesGroup = () => {
  const [seriesGroups, setSeriesGroups] = useState<ISeriesGroupResponse[]>([]);
  const [seriesGroupOptions, setSeriesGroupOptions] = useState<ISelectOption[]>(
    []
  );

  const stateManager = useComponentState();

  const getSeriesGroups = ({
    filters,
    sort = "name",
    params,
    signal,
    top,
    skip,
  }: IApiRequest = {}) => {
    return stateManager.run(async () => {
      const response = await homeService.seriesGroup.getAll({
        filters,
        sort,
        params,
        signal,
        top,
        skip,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setSeriesGroups(response.data);
      }
      return response;
    });
  };

  const getSeriesGroupOptions = ({
    filters,
    sort = "name",
    params,
    signal,
    top,
    skip,
  }: IApiRequest = {}) => {
    return stateManager.run(async () => {
      const response = await homeService.seriesGroup.getAll({
        filters,
        sort,
        params,
        signal,
        top,
        skip,
      });
      if (response.status === HTTP_STATUSES.OK) {
        const options = response.data.map(
          (seriesGroup: ISeriesGroupResponse) => ({
            label: seriesGroup.name,
            value: seriesGroup.id,
          })
        );
        setSeriesGroupOptions(options);
      }
      return response;
    });
  };

  const createSeriesGroup = (data: Omit<ISeriesGroupResponse, "id">) => {
    return stateManager.run(async () => {
      return homeService.seriesGroup.create({
        data,
        toastMessageConfig: {
          success: {
            text: `Successfully created Series Group: ${data.name}.`,
          },
        },
      });
    });
  };

  const updateSeriesGroup = (data: Partial<ISeriesGroupResponse>) => {
    return stateManager.run(async () => {
      return homeService.seriesGroup.update({
        data,
        toastMessageConfig: {
          success: {
            text: `Successfully updated Series Group: ${data.name}.`,
          },
        },
      });
    });
  };

  const deleteSeriesGroup = (data: Partial<ISeriesGroupResponse>) => {
    return stateManager.run(async () => {
      return homeService.seriesGroup.delete({
        data,
        toastMessageConfig: {
          success: {
            text: `Series Group ${data.name} was deleted successfully.`,
          },
        },
      });
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    seriesGroups,
    seriesGroupOptions,
    setSeriesGroups,
    getSeriesGroups,
    getSeriesGroupOptions,
    createSeriesGroup,
    updateSeriesGroup,
    deleteSeriesGroup,
  };
};
